import { AppNavParams } from '@euler/app/Routes';
import { MediaPreview } from '@euler/app/components/media/MediaPreview';
import { Typography } from '@euler/app/components/typography';
import { Center } from '@euler/components/Center';
import { Icon } from '@euler/components/Icomoon';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { useIsMobileLayout } from '@euler/functions/responsiveness';
import { wrapNavigatorScreen } from '@euler/functions/wrapNavigatorScreen';
import { useNavigation } from '@react-navigation/native';
import {
  CardStyleInterpolators,
  StackNavigationProp,
} from '@react-navigation/stack';
import { TouchableOpacity } from 'react-native';
import { ResizeMode } from 'react-native-fast-image';
import {
  SafeAreaView,
  useSafeAreaInsets,
} from 'react-native-safe-area-context';

export const MediaPreviewScreen = wrapNavigatorScreen(
  (props: {
    type: 'video' | 'photo';
    url: string;
    resizeMode?: ResizeMode | 'stretch' | 'cover' | 'contain';
    retakeText?: string;
    shareable?: boolean;
    onRetake?: () => void;
    onConfirm?: (url: string) => void;
  }) => {
    const { left, right, bottom } = useSafeAreaInsets();
    const { rpx } = useResponsiveContext();
    const isMobileLayout = useIsMobileLayout();
    const navigation = useNavigation<StackNavigationProp<AppNavParams>>();
    return (
      <SafeAreaView
        css={`
          flex: 1;
          background-color: black;
        `}
      >
        {props.type === 'photo' && (
          <MediaPreview
            type={props.type}
            url={props.url}
            shareable={props.shareable}
            resizeMode={props.resizeMode}
            onClose={() => navigation.goBack()}
          />
        )}
        {props.type === 'video' && (
          <MediaPreview
            type={props.type}
            url={props.url}
            shareable={props.shareable}
            controls={true}
            onClose={() => navigation.goBack()}
          />
        )}
        <Center
          pointerEvents="box-none"
          css={`
            position: absolute;
            left: ${left}px;
            right: ${right}px;
            bottom: ${bottom + rpx(32)}px;
            flex-direction: row;
          `}
        >
          {props.onRetake && (
            <TouchableOpacity
              onPress={props.onRetake}
              css={`
                align-items: center;
              `}
            >
              <Center>
                <Icon
                  name="camera-fill"
                  color="#ffff"
                  size={rpx(isMobileLayout ? 44 : 64)}
                />
              </Center>
              <Typography.Label
                color="#fff"
                medium
                size={rpx(16)}
                css={`
                  text-align: center;
                `}
              >
                {props.retakeText ?? '重拍'}
              </Typography.Label>
            </TouchableOpacity>
          )}
        </Center>
      </SafeAreaView>
    );
  },
  {
    presentation: 'transparentModal',
    headerTransparent: true,
    headerShown: false,
    title: 'Preview',
    cardStyleInterpolator: CardStyleInterpolators.forFadeFromBottomAndroid,
  },
);
